import { render, staticRenderFns } from "./ModalConfirmDelete.vue?vue&type=template&id=1d81f6f6&"
import script from "./ModalConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports